import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as add } from './configurations/add';
import { apiAction as get } from './configurations/get';
import { apiAction as getExport } from './configurations/getExport';
import { apiAction as loadMore } from './configurations/loadMore';

export const apiActions = {
  cpdPoints: {
    get,
    getExport,
    add,
    loadMore
  }
}

const actions = mapActionsFromConfigurations('cpdPoints')(configurations);

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/actions.js